export const DESMEMBRAMENTO_DTO = [
  {
    "numeroDocumento": "7171808685799073",
    "sequencialDesmembramento": 1,
    "numeroRegistro": null,
    "periodoApuracao": "2018-03-29",
    "dataVencimento": "2018-03-29",
    "destinacao": {
      "codigo": "1",
      "descricao": "União"
    },
    "valorTotal": 205.24,
    "sistemaInteresse": {
      "codigo": 38,
      "descricao": "SISPAR"
    },
    "referencia": "70115065058",
    "identificadorDepositoCEF": null,
    "processo": null,
    "unidadeFederativaSigla": null,
    "uaClassificacaoCodigo": null,
    "valorPrincipal": 130.3,
    "valorMulta": 48.86,
    "valorJuros": 26.08,
    "valorSaldoPrincipal": 130.3,
    "valorSaldoMulta": 48.86,
    "valorSaldoJuros": 15.07,
    "numeroIdentificadorParcelamento": 1852236,
    "uaClassificacaoPGFPGFN": null,
    "indicadorOrigem": 2,
    "ug": null,
    "gestao": null,
    "indicadorOcorrencia": 1,
    "numeroInscricaoDAU": null,
    "numeroCib": null,
    "numeroCadastroNacionalObras": null,
    "numeroIdentificacaoTrabalhador": null,
    "cnpjPrestador": null,
    "cpfSegurado": null,
    "modalidadeParcelamento": null,
    "municipio": null,
    "municipioClassificacao": null,
    "cnpjBaseDebito": null,
    "cnpjOrdemDebito": null,
    "cpfDebito": null,
    "cnpjBaseFornecedor": null,
    "cnpjOrdemFornecedor": null,
    "cpfFornecedor": null,
    "numeroDocumentoFiscal": null,
    "fracoes": [
      {
        "numeroDocumento": "7171808685799073",
        "sequencialFracao": 3,
        "valor": 26.08,
        "receita": {
          "receitaCodigo": 365,
          "receitaNome": "Juros - IRPF - Parcelamentos - Dívida ativa",
          "extensaoReceitaCodigo": null,
          "extensaoReceitaTexto": null
        },
        "tipoFracao": {
          "codigo": 3,
          "descricao": "Juros"
        },
        "valorSaldo": null,
        "versao": null
      },
      {
        "numeroDocumento": "7171808685799073",
        "sequencialFracao": 2,
        "valor": 48.86,
        "receita": {
          "receitaCodigo": 253,
          "receitaNome": "Multa - IRPF - Parcelamentos - Dívida ativa",
          "extensaoReceitaCodigo": null,
          "extensaoReceitaTexto": null
        },
        "tipoFracao": {
          "codigo": 2,
          "descricao": "Multa"
        },
        "valorSaldo": null,
        "versao": null
      },
      {
        "numeroDocumento": "7171808685799073",
        "sequencialFracao": 1,
        "valor": 130.3,
        "receita": {
          "receitaCodigo": 141,
          "receitaNome": "Receita da dívida ativa - IRPF - Parcelamentos",
          "extensaoReceitaCodigo": null,
          "extensaoReceitaTexto": null
        },
        "tipoFracao": {
          "codigo": 1,
          "descricao": "Principal"
        },
        "valorSaldo": null,
        "versao": null
      }
    ],
    "procInfoComplementar": null,
    "versao": null,
    "dataAtualizacao": null,
    "cpfAtualizacao": null,
    "uaAtualizacao": null,
    "procNrRetificacao": null,
    "terminalAtualizacao": null,
    "versaoDocumento": null,
    "situacao": "ORIGINAL"
  },
  {
    "numeroDocumento": "9012205400026256",
    "sequencialDesmembramento": 2,
    "numeroRegistro": null,
    "periodoApuracao": "2022-01-31",
    "dataVencimento": "2022-02-18",
    "destinacao": {
      "codigo": "1",
      "descricao": "União"
    },
    "valorTotal": 198.08,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "referencia": null,
    "identificadorDepositoCEF": null,
    "processo": null,
    "unidadeFederativaSigla": null,
    "uaClassificacaoCodigo": null,
    "valorPrincipal": 198.08,
    "valorMulta": 0,
    "valorJuros": 0,
    "valorSaldoPrincipal": 48.05,
    "valorSaldoMulta": 0,
    "valorSaldoJuros": 0,
    "numeroIdentificadorParcelamento": null,
    "uaClassificacaoPGFPGFN": null,
    "indicadorOrigem": 1,
    "ug": null,
    "gestao": null,
    "indicadorOcorrencia": null,
    "numeroInscricaoDAU": null,
    "numeroCib": null,
    "numeroCadastroNacionalObras": null,
    "numeroIdentificacaoTrabalhador": null,
    "cnpjPrestador": null,
    "cpfSegurado": null,
    "modalidadeParcelamento": null,
    "municipio": null,
    "municipioClassificacao": null,
    "cnpjBaseDebito": null,
    "cnpjOrdemDebito": null,
    "cpfDebito": null,
    "cnpjBaseFornecedor": null,
    "cnpjOrdemFornecedor": null,
    "cpfFornecedor": null,
    "numeroDocumentoFiscal": null,
    "fracoes": [
      {
        "numeroDocumento": "9012205400026256",
        "sequencialFracao": 1,
        "valor": 198.08,
        "receita": {
          "receitaCodigo": 1082,
          "receitaNome": "Contribuição previdenciária descontada de segurados empregados e avulsos e de trabalhadores rurais contratados por pequeno prazo.",
          "extensaoReceitaCodigo": 1,
          "extensaoReceitaTexto": "CP SEGURADOS - EMPREGADOS/AVULSO"
        },
        "tipoFracao": {
          "codigo": 1,
          "descricao": "Principal"
        },
        "valorSaldo": null,
        "versao": null
      }
    ],
    "procInfoComplementar": null,
    "versao": null,
    "dataAtualizacao": null,
    "cpfAtualizacao": null,
    "uaAtualizacao": null,
    "procNrRetificacao": null,
    "terminalAtualizacao": null,
    "versaoDocumento": null,
    "situacao": "ALTERADO"
  },
  {
    "numeroDocumento": "7202334869381815",
    "sequencialDesmembramento": 3,
    "numeroRegistro": null,
    "periodoApuracao": "2023-11-01",
    "dataVencimento": "2023-12-20",
    "destinacao": {
      "codigo": "1",
      "descricao": "União"
    },
    "valorTotal": 2007.52,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "referencia": null,
    "identificadorDepositoCEF": null,
    "processo": null,
    "unidadeFederativaSigla": null,
    "uaClassificacaoCodigo": null,
    "valorPrincipal": 2007.52,
    "valorMulta": 0,
    "valorJuros": 0,
    "valorSaldoPrincipal": 0,
    "valorSaldoMulta": 0,
    "valorSaldoJuros": 0,
    "numeroIdentificadorParcelamento": null,
    "uaClassificacaoPGFPGFN": null,
    "indicadorOrigem": 1,
    "ug": null,
    "gestao": null,
    "indicadorOcorrencia": null,
    "numeroInscricaoDAU": null,
    "numeroCib": null,
    "numeroCadastroNacionalObras": null,
    "numeroIdentificacaoTrabalhador": null,
    "cnpjPrestador": null,
    "cpfSegurado": null,
    "modalidadeParcelamento": null,
    "municipio": null,
    "municipioClassificacao": null,
    "cnpjBaseDebito": null,
    "cnpjOrdemDebito": null,
    "cpfDebito": null,
    "cnpjBaseFornecedor": null,
    "cnpjOrdemFornecedor": null,
    "cpfFornecedor": null,
    "numeroDocumentoFiscal": null,
    "fracoes": [
      {
        "numeroDocumento": "7202334869381815",
        "sequencialFracao": 1,
        "valor": 2007.52,
        "receita": {
          "receitaCodigo": 1001,
          "receitaNome": "IRPJ - SIMPLES NACIONAL",
          "extensaoReceitaCodigo": null,
          "extensaoReceitaTexto": null
        },
        "tipoFracao": {
          "codigo": 1,
          "descricao": "Principal"
        },
        "valorSaldo": null,
        "versao": null
      }
    ],
    "procInfoComplementar": null,
    "versao": null,
    "dataAtualizacao": null,
    "cpfAtualizacao": null,
    "uaAtualizacao": null,
    "procNrRetificacao": null,
    "terminalAtualizacao": null,
    "versaoDocumento": null,
    "situacao": "ORIGINAL"
  },
  {
    "numeroDocumento": "7202334869381815",
    "sequencialDesmembramento": 4,
    "numeroRegistro": null,
    "periodoApuracao": "2023-11-01",
    "dataVencimento": "2023-12-20",
    "destinacao": {
      "codigo": "1",
      "descricao": "União"
    },
    "valorTotal": 1072.12,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "referencia": null,
    "identificadorDepositoCEF": null,
    "processo": null,
    "unidadeFederativaSigla": null,
    "uaClassificacaoCodigo": null,
    "valorPrincipal": 1072.12,
    "valorMulta": 0,
    "valorJuros": 0,
    "valorSaldoPrincipal": 0,
    "valorSaldoMulta": 0,
    "valorSaldoJuros": 0,
    "numeroIdentificadorParcelamento": null,
    "uaClassificacaoPGFPGFN": null,
    "indicadorOrigem": 1,
    "ug": null,
    "gestao": null,
    "indicadorOcorrencia": null,
    "numeroInscricaoDAU": null,
    "numeroCib": null,
    "numeroCadastroNacionalObras": null,
    "numeroIdentificacaoTrabalhador": null,
    "cnpjPrestador": null,
    "cpfSegurado": null,
    "modalidadeParcelamento": null,
    "municipio": null,
    "municipioClassificacao": null,
    "cnpjBaseDebito": null,
    "cnpjOrdemDebito": null,
    "cpfDebito": null,
    "cnpjBaseFornecedor": null,
    "cnpjOrdemFornecedor": null,
    "cpfFornecedor": null,
    "numeroDocumentoFiscal": null,
    "fracoes": [
      {
        "numeroDocumento": "7202334869381815",
        "sequencialFracao": 4,
        "valor": 1072.12,
        "receita": {
          "receitaCodigo": 1005,
          "receitaNome": "PIS - SIMPLES NACIONAL",
          "extensaoReceitaCodigo": null,
          "extensaoReceitaTexto": null
        },
        "tipoFracao": {
          "codigo": 1,
          "descricao": "Principal"
        },
        "valorSaldo": null,
        "versao": null
      }
    ],
    "procInfoComplementar": null,
    "versao": null,
    "dataAtualizacao": null,
    "cpfAtualizacao": null,
    "uaAtualizacao": null,
    "procNrRetificacao": null,
    "terminalAtualizacao": null,
    "versaoDocumento": null,
    "situacao": "ORIGINAL"
  },
  {
    "numeroDocumento": "7202334869381815",
    "sequencialDesmembramento": 5,
    "numeroRegistro": null,
    "periodoApuracao": "2023-11-01",
    "dataVencimento": "2023-12-20",
    "destinacao": {
      "codigo": "1",
      "descricao": "União"
    },
    "valorTotal": 16406.71,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "referencia": null,
    "identificadorDepositoCEF": null,
    "processo": null,
    "unidadeFederativaSigla": null,
    "uaClassificacaoCodigo": null,
    "valorPrincipal": 16406.71,
    "valorMulta": 0,
    "valorJuros": 0,
    "valorSaldoPrincipal": 0,
    "valorSaldoMulta": 0,
    "valorSaldoJuros": 0,
    "numeroIdentificadorParcelamento": null,
    "uaClassificacaoPGFPGFN": null,
    "indicadorOrigem": 1,
    "ug": null,
    "gestao": null,
    "indicadorOcorrencia": null,
    "numeroInscricaoDAU": null,
    "numeroCib": null,
    "numeroCadastroNacionalObras": null,
    "numeroIdentificacaoTrabalhador": null,
    "cnpjPrestador": null,
    "cpfSegurado": null,
    "modalidadeParcelamento": null,
    "municipio": null,
    "municipioClassificacao": null,
    "cnpjBaseDebito": null,
    "cnpjOrdemDebito": null,
    "cpfDebito": null,
    "cnpjBaseFornecedor": null,
    "cnpjOrdemFornecedor": null,
    "cpfFornecedor": null,
    "numeroDocumentoFiscal": null,
    "fracoes": [
      {
        "numeroDocumento": "7202334869381815",
        "sequencialFracao": 5,
        "valor": 16406.71,
        "receita": {
          "receitaCodigo": 1006,
          "receitaNome": "INSS - SIMPLES NACIONAL",
          "extensaoReceitaCodigo": null,
          "extensaoReceitaTexto": null
        },
        "tipoFracao": {
          "codigo": 1,
          "descricao": "Principal"
        },
        "valorSaldo": null,
        "versao": null
      }
    ],
    "procInfoComplementar": null,
    "versao": null,
    "dataAtualizacao": null,
    "cpfAtualizacao": null,
    "uaAtualizacao": null,
    "procNrRetificacao": null,
    "terminalAtualizacao": null,
    "versaoDocumento": null,
    "situacao": "ORIGINAL"
  }
]